module.exports = __webpack_public_path__ + "static/media/SI.4279aabf.svg";